module.exports = __webpack_public_path__ + "img/13.905aa9a5.jpg";